// extracted by css-extract-rspack-plugin
export default {"title":"R5tn9B"};